import {Component, forwardRef, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALIDATORS, NG_VALUE_ACCESSOR} from '@angular/forms';
import {NbFieldType} from "./nbinput.entity";

@Component({
  selector: 'nbinput-label',
  template: require('./nbinput-label.component.html'),
  styles: [require('./nbinput-image.component.scss')],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputLabelComponent),
      multi: true
    }
  ]
})

export class NbinputLabelComponent implements ControlValueAccessor {
    writeValue(obj: string): void {
        setTimeout(()=> {
            this.data = obj;
        }, 0);
    }
    private onTouchedCallback = () => {};
    private onChangeCallback = (_) => {};
    registerOnChange(fn: any): void {if(fn)this.onChangeCallback = fn;}
    registerOnTouched(fn: any): void {if(fn)this.onTouchedCallback = fn;}
    public disabled = false;
    setDisabledState?(isDisabled: boolean): void {this.disabled = isDisabled}
  public FieldType = NbFieldType;

  @Input() data;
  @Input() type:NbFieldType = NbFieldType.Text;

  constructor(
  ) {}
}
